<template>
  <div>
    <div class="flex justify-center" slot="actions">
      <vs-button
        type="filled"
        color="success"
        class="w-full"
        @click="downloadPDF()">
        Download PDF
      </vs-button>
    </div>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';

export default {
  name: 'member-stats-report',
  props: {
    member: ResourceImpl,
    selectedPeriod: Array
  },
  data () {
    return {
      mentalHealthStatus: null,
      userIdLabel: null
    };
  },
  computed: {
    period () {
      return {
        start: this.selectedPeriod[0],
        end: this.selectedPeriod[1]
      };
    }
  },
  methods: {
    downloadPDF () {
      if (this.member.$hasLink('member-report')) {
        const xhr = new XMLHttpRequest();
        xhr.open('GET', this.member.$href('member-report', {startDate: new Date(this.period.start).toISOString().substring(0, 10), endDate: new Date(this.period.end).toISOString().substring(0, 10)}), true);
        xhr.setRequestHeader('Authorization', this.$store.state.account.accessToken);
        xhr.responseType = 'blob';

        xhr.onload = () => {
          if (xhr.status === 200) {
            const fileLink = document.createElement('a');
            fileLink.href = (window.URL || window.webkitURL).createObjectURL(xhr.response, {type: 'application/octet-stream'});
            const contentDisposition = xhr.getResponseHeader('content-disposition');
            const filename = contentDisposition && contentDisposition.indexOf('filename') ? contentDisposition.split('filename="')[1].split('"')[0] : 'member-report.zip';
            fileLink.setAttribute('download', filename);
            document.body.appendChild(fileLink);

            fileLink.click();
            document.body.removeChild(fileLink);
          }
        };
        xhr.send();
      }
    }
  }
};
</script>
